import React from 'react';
import { Typography } from 'seagull';
import cn from 'classnames';
import { InformationLiner24 } from 'seagull/icons';
import { timeModel } from "../../models";
import styles from "./ChangesApprovalInfoBox.module.scss";
export default function ChangesApprovalInfoBox(props) {
  const {
    testid,
    autoApprovalDate,
    className
  } = props;
  return /*#__PURE__*/React.createElement(Typography, {
    className: cn(styles.infoBox, className),
    skin: "primary"
  }, /*#__PURE__*/React.createElement(InformationLiner24, null), /*#__PURE__*/React.createElement(Typography, {
    "data-testid": testid
  }, autoApprovalDate ? "Will be auto-accepted on ".concat(timeModel.formatDate(autoApprovalDate), " unless declined or approved earlier.") : 'Changes are awaiting approval.'));
}